import { DialogActions, Button } from "@mui/material";
import React from "react";
import GlobalButton from "../button";
import { t } from "i18next";

const DialogActionButtons = ({
  onConfirm,
  onCancel,
  confirmText = "confirm",
  cancelText = "cancel",
  isConfirmBtnDisable = false,
}) => {
  return (
    <DialogActions
      sx={{
        padding: "12px",
      }}
    >
      <GlobalButton
        variant={"outlined"}
        handleClickBtn={onCancel}
        btnText={t(cancelText)}
      />
      <GlobalButton
        variant={"contained"}
        handleClickBtn={onConfirm}
        btnText={t(confirmText)}
        disabled={isConfirmBtnDisable}
      />
    </DialogActions>
  );
};

export default DialogActionButtons;
